import { render } from "./App.vue?vue&type=template&id=fe872736"
const script = {}

import "./App.vue?vue&type=style&index=0&id=fe872736&lang=postcss"

import exportComponent from "../node_modules/.pnpm/registry.npmmirror.com+vue-loader@17.3.1_@vue+compiler-sfc@3.3.8_vue@3.3.8_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__